<template>
    <SupplyProducts/>
  </template>
  
  <script>
  import SupplyProducts from './SupplyProducts.vue'
  export default {
    components: {
        SupplyProducts
    },
    data () {
      return {
  
      }
    },
    created () {
      this.$store.commit('updateTitle', 'Productos de Insumos')
    }
  }
  </script>


// WEBPACK FOOTER //
// src/components/ProductosInsumos.vue